export const ROOM_IMAGE_BEFORE = '/images/gallery_dining/dining-minimal-0-0.webp';
export const ROOM_IMAGE_AFTER = '/images/gallery_living/Living-modern-0-0.webp';

const SHOPPING_CARD = '/images/shooping card';

export const ZONES = [
  {
    id: 'tvStand',
    label: 'TV stand',
    bbox: { left: 27, top: 53, width: 50, height: 15 },
    products: [
      { name: 'Lune TV Stand', brand: 'West Elm', price: '$1,699', icon: 'tvStand', image: `${SHOPPING_CARD}/stand-1.webp` },
      { name: 'Kivik TV Unit', brand: 'IKEA', price: '$899', icon: 'tvStand', image: `${SHOPPING_CARD}/stand-2.webp` },
      { name: 'Andes Media Console', brand: 'Amazon', price: '$1,498', icon: 'tvStand', image: `${SHOPPING_CARD}/stand-1.webp` },
      { name: 'Harlow TV Stand', brand: 'Article', price: '$1,299', icon: 'tvStand', image: `${SHOPPING_CARD}/stand-2.webp` },
    ],
  },
  {
    id: 'coffeeTable',
    label: 'Coffee table',
    bbox: { left: 34.5, top: 65, width: 31, height: 22 },
    products: [
      { name: 'Coffee Table', brand: 'Amazon', price: '$449', icon: 'table', image: `${SHOPPING_CARD}/table-1.webp` },
      { name: 'Coffee Table', brand: 'IKEA', price: '$49', icon: 'table', image: `${SHOPPING_CARD}/table-2.webp` },
      { name: 'Nesting Set', brand: 'Target', price: '$129', icon: 'table', image: `${SHOPPING_CARD}/table-1.webp` },
      { name: 'Mid-Cent Table', brand: 'West Elm', price: '$599', icon: 'table', image: `${SHOPPING_CARD}/table-2.webp` },
    ],
  },
  {
    id: 'accentChair',
    label: 'Accent chair',
    bbox: { left: 71, top: 57, width: 24, height: 32 },
    products: [
      { name: 'Lounge Chair', brand: 'Amazon', price: '$6,495', icon: 'chair', image: `${SHOPPING_CARD}/chair-1.webp` },
      { name: 'Strandmon Chair', brand: 'IKEA', price: '$279', icon: 'chair', image: `${SHOPPING_CARD}/chair-2.webp` },
      { name: 'Velvet Chair', brand: 'Wayfair', price: '$349', icon: 'chair', image: `${SHOPPING_CARD}/chair-1.webp` },
    ],
  },
  {
    id: 'chandelier',
    label: 'Chandelier',
    bbox: { left: 36, top: 6.5, width: 25, height:19 },
    products: [
      { name: 'Brass Chandelier', brand: 'Amazon', price: '$499', icon: 'lamp', image: `${SHOPPING_CARD}/chand-1.webp` },
      { name: 'Sputnik Pendant', brand: 'West Elm', price: '$349', icon: 'lamp', image: `${SHOPPING_CARD}/chand-2.webp` },
      { name: 'Crystal Chandelier', brand: 'Wayfair', price: '$219', icon: 'lamp', image: `${SHOPPING_CARD}/chand-3.webp` },
      { name: 'Modern Light', brand: 'Amazon', price: '$399', icon: 'lamp', image: `${SHOPPING_CARD}/chand-1.webp` },
    ],
  },
];
